export var OperatingSystem;
(function (OperatingSystem) {
    OperatingSystem["Windows"] = "windows";
    OperatingSystem["Linux"] = "linux";
})(OperatingSystem || (OperatingSystem = {}));
//# sourceMappingURL=OperatingSystem.js.map